<template>
  <v-app app>
    <notification></notification>
    <transition name="app-transition" mode="out-in">
      <sidebar-component v-if="sidebar" :miniVariant="miniVariant" />
    </transition>
    <transition name="app-transition" mode="out-in">
      <header-component v-if="header" @switchMiniVariant="switchMiniVariant" />
    </transition>
    <v-main>
      <header-setup-mode-banner v-if="header" />
      <permanent-notifications />
      <transition name="router-view-transition" mode="out-in">
        <router-view />
      </transition>
    </v-main>
    <!-- <v-footer app inset absolute>
      <span>&nbsp; &nbsp; &copy; 2018 Outfox AI.  Made with &hearts; in NYC</span>
    </v-footer> -->
  </v-app>
</template>

<script>
import firebase from 'firebase/app'
// import Intercom from './Intercom'
import Notification from './components/helpers/Notification.vue'
import HeaderComponent from './components/header/Index.vue'
import SidebarComponent from './components/sidebar/Index.vue'
import PermanentNotifications from './components/helpers/ThePemanentNotifications'
import HeaderSetupModeBanner from './components/header/HeaderSetupModeBanner'
export default {
  name: 'App',
  components: {
    Notification,
    HeaderComponent,
    SidebarComponent,
    PermanentNotifications,
    HeaderSetupModeBanner
  },
  data() {
    return {
      miniVariant: false,
      header: false,
      sidebar: false
    }
  },
  created() {
    // this.injectIntercom()
    this.$store.dispatch('fetchFeatures')
    // Note: check version

    if (window.location.href.includes('https://outfox-dev.firebaseapp.com')) {
      this.$store.dispatch('setAppVersion', 'mobilizev2')
    } else if (window.location.href.indexOf('mobilizev2/demo') !== -1) {
      this.$store.dispatch('setAppVersion', 'mobilizev2demo')
    } else if (window.location.href.indexOf('demo') !== -1) {
      this.$store.dispatch('setAppVersion', 'demo')
    } else if (window.location.href.indexOf('app') !== -1) {
      this.$store.dispatch('setAppVersion', 'app')
    } else if (window.location.href.indexOf('mobilizev2') !== -1) {
      this.$store.dispatch('setAppVersion', 'mobilizev2')
      if (!window.location.pathname.startsWith('/mobilizev2')) {
        this.$router.push('/mobilizev2')
      }
    } else if (window.location.href.indexOf('mobilize') !== -1) {
      this.$store.dispatch('setAppVersion', 'mobilize')
    }

    if (localStorage.getItem('outfoxUser')) {
      new Promise(resolve => {
        resolve(this.$store.dispatch('login'))
      }).then(res => {
        if (!this.user.firebaseAccount.selectedAdvertiser) {
          this.$router.push('/welcome')
        } else {
          if (this.$store.state.featureToggle.appVersion === 'dev') {
            this.$store.dispatch('fetchApiData')
          }
        }
      })
    } else firebase.auth().signOut()
  },
  computed: {
    user() {
      return this.$store.getters.getCurrentUser
      // },
      // intercom () {
      //   return this.$store.getters.getIntercom
    }
  },
  methods: {
    switchMiniVariant() {
      this.miniVariant = !this.miniVariant
    },
    injectIntercom() {
      const w = window
      const ic = w.Intercom
      function l() {
        let s = document.createElement('script')
        s.type = 'text/javascript'
        s.async = true
        s.src = 'https://widget.intercom.io/widget/bmo7f66r'
        let x = document.getElementsByTagName('script')[0]
        x.parentNode.insertBefore(s, x)
      }
      if (typeof ic === 'function') {
        ic('reattach_activator')
        ic('update')
      } else {
        let i = function() {
          i.c(arguments)
        }
        i.q = []
        i.c = function(args) {
          i.q.push(args)
        }
        w.Intercom = i
        if (w.attachEvent) {
          w.attachEvent('onload', l)
        } else w.addEventListener('load', l, false)
      }
    }
  },
  watch: {
    $route(val) {
      if (val.path !== '/login') {
        const user = JSON.parse(localStorage.getItem('outfoxUser'))
        if (!user) {
          this.$router.push('/login')
        } else if (
          !user.firebaseAccount ||
          !user.firebaseAccount.advertisers ||
          !user.firebaseAccount.advertisers.length
        ) {
          const forbiddenPaths = ['/campaigns/new', '/welcome']
          if (!forbiddenPaths.find(path => path === val.path)) {
            this.$router.push('/setup-checklist')
          }
        }
      }
      // Note: hide sidebar and header
      const blockedPaths = ['Welcome', 'SetupChecklistPreview', 'Login', 'ErrorsHandling']
      if (blockedPaths.find(path => path === val.name)) {
        this.sidebar = false
        this.header = false
      } else {
        this.sidebar = true
        this.header = true
        // Note: update intercom then route changed
        // if (this.intercom) {
        //   const intercom = new Intercom()
        //   intercom.softUpdate()
        // }
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import 'assets/scss/app';
.app-transition-enter-active {
  transition: opacity 3s ease;
}
.app-transition-enter {
  opacity: 0;
}
.router-view-transition-enter-active {
  transition: opacity 0.5s ease;
}
.router-view-transition-enter {
  opacity: 0;
}
/*.component-fade-leave {*/
/*opacity: 0;*/
/*}*/
</style>
